// INSURANCE (Försäkra bilen) — DEMO DATA, hard-coded in the front end only.
//
// Klargo does not broker insurance and nothing here is read from or written to the backend: the
// vehicle, the seller, the insurers, the prices and the policy are invented for the demo page the
// buyer reaches after the seller has reported the ownership transfer. Nothing is saved.

export const DEMO_VEHICLE = {
  registrationNumber: "ABC123",
  make: "Porsche",
  model: "Cayenne",
  year: 2015,
};

export const DEMO_SELLER_NAME = "Anna Andersson";

/** The day the ownership transfer is reported, which is also the day the cover starts. */
export const DEMO_TRANSFER_DATE = "2026-07-20";

export const COVERAGE_LEVELS = ["trafik", "halv", "hel"];
export const DEFAULT_LEVEL = "trafik";

const DOCS = ["Förköpsinformation", "Fullständiga villkor"];

const TRAFIK = [
  {
    id: "trygghansa-trafik", insurer: "Trygg-Hansa", level: "trafik", monthlySek: 96, annualSek: 1152, deductibleSek: 1500,
    highlights: ["Skada på andra", "Personskada"],
    covers: ["Personskador på förare och passagerare", "Skador du orsakar på andras egendom"],
    exclusions: ["Alla skador på din egen bil", "Stöld", "Brand", "Glas"],
    deductibles: [{ label: "Grundsjälvrisk", amountSek: 1500 }],
    documents: DOCS,
  },
  {
    id: "if-trafik", insurer: "If", level: "trafik", monthlySek: 104, annualSek: 1248, deductibleSek: 1200,
    highlights: ["Skada på andra", "Personskada"],
    covers: ["Personskador på förare och passagerare", "Skador du orsakar på andras egendom"],
    exclusions: ["Alla skador på din egen bil", "Stöld", "Brand", "Glas"],
    deductibles: [{ label: "Grundsjälvrisk", amountSek: 1200 }],
    documents: DOCS,
  },
  {
    id: "moderna-trafik", insurer: "Moderna", level: "trafik", monthlySek: 92, annualSek: 1104, deductibleSek: 1800,
    highlights: ["Skada på andra", "Personskada"],
    covers: ["Personskador på förare och passagerare", "Skador du orsakar på andras egendom"],
    exclusions: ["Alla skador på din egen bil", "Stöld", "Brand", "Glas"],
    deductibles: [{ label: "Grundsjälvrisk", amountSek: 1800 }],
    documents: DOCS,
  },
];

const HALV = [
  {
    id: "trygghansa-halv", insurer: "Trygg-Hansa", level: "halv", monthlySek: 189, annualSek: 2268, deductibleSek: 3000,
    highlights: ["Maskinskada", "Räddning och bärgning", "Rättsskydd"],
    covers: [
      "Stöld och stöldförsök", "Brand och explosion", "Glasskada på ruta", "Räddning och bärgning i Norden",
      "Rättsskydd vid tvist om bilen", "Maskinskada till 8 års ålder eller 10 000 mil",
    ],
    exclusions: ["Skador på egen bil vid kollision", "Hyrbil", "Skador vid uthyrning"],
    deductibles: [
      { label: "Grundsjälvrisk", amountSek: 3000 },
      { label: "Glasreparation", amountSek: 0, note: "Vid reparation i stället för byte" },
      { label: "Maskinskada", amountSek: 4000 },
    ],
    documents: DOCS,
  },
  {
    id: "if-halv", insurer: "If", level: "halv", monthlySek: 219, annualSek: 2628, deductibleSek: 1800,
    highlights: ["Maskinskada", "Assistans dygnet runt", "Hyrbil 75 %"],
    covers: [
      "Stöld och stöldförsök", "Brand och explosion", "Glasskada på ruta", "Assistans dygnet runt i hela Norden",
      "Hyrbil med 75 % av dygnskostnaden i högst 45 dagar", "Maskinskada till 8 års ålder eller 10 000 mil",
    ],
    exclusions: ["Skador på egen bil vid kollision", "Skador vid tävling på bana"],
    deductibles: [
      { label: "Grundsjälvrisk", amountSek: 1800, note: "Sänks 500 kr efter tre skadefria år" },
      { label: "Glasreparation", amountSek: 0 },
      { label: "Maskinskada", amountSek: 3500 },
    ],
    documents: DOCS,
  },
  {
    id: "moderna-halv", insurer: "Moderna", level: "halv", monthlySek: 175, annualSek: 2100, deductibleSek: 4000,
    highlights: ["Räddning och bärgning", "Rättsskydd"],
    covers: [
      "Stöld och stöldförsök", "Brand och explosion", "Glasskada på ruta", "Räddning och bärgning",
      "Rättsskydd upp till 250 000 kr per tvist",
    ],
    exclusions: ["Maskinskada", "Skador på egen bil vid kollision", "Hyrbil"],
    deductibles: [
      { label: "Grundsjälvrisk", amountSek: 4000 },
      { label: "Rättsskydd", amountSek: 2000, note: "20 % av kostnaden därutöver" },
    ],
    documents: DOCS,
  },
];

const HEL = [
  {
    id: "if-hel", insurer: "If", level: "hel", monthlySek: 341, annualSek: 4092, deductibleSek: 4500,
    highlights: ["Vagnskada", "Maskinskada", "Hyrbil 75 %"],
    covers: [
      "Allt som ingår i halvförsäkringen", "Vagnskada vid kollision, dikeskörning och skadegörelse",
      "Hyrbil med 75 % av dygnskostnaden",
    ],
    exclusions: ["Skador vid tävling på bana", "Skador vid uthyrning"],
    deductibles: [
      { label: "Grundsjälvrisk", amountSek: 1800 },
      { label: "Vagnskada", amountSek: 4500, note: "Separat från övriga moment" },
    ],
    documents: DOCS,
  },
  {
    id: "trygghansa-hel", insurer: "Trygg-Hansa", level: "hel", monthlySek: 318, annualSek: 3816, deductibleSek: 5000,
    highlights: ["Vagnskada", "Maskinskada", "Rättsskydd"],
    covers: ["Allt som ingår i halvförsäkringen", "Vagnskada vid kollision, dikeskörning och skadegörelse"],
    exclusions: ["Hyrbil", "Skador vid tävling på bana"],
    deductibles: [
      { label: "Grundsjälvrisk", amountSek: 3000 },
      { label: "Vagnskada", amountSek: 5000, note: "Kan sänkas mot högre premie" },
    ],
    documents: DOCS,
  },
  {
    id: "moderna-hel", insurer: "Moderna", level: "hel", monthlySek: 299, annualSek: 3588, deductibleSek: 6000,
    highlights: ["Vagnskada", "Räddning och bärgning"],
    covers: ["Allt som ingår i halvförsäkringen", "Vagnskada vid kollision och dikeskörning"],
    exclusions: ["Maskinskada", "Hyrbil"],
    deductibles: [
      { label: "Grundsjälvrisk", amountSek: 4000 },
      { label: "Vagnskada", amountSek: 6000 },
    ],
    documents: DOCS,
  },
];

const BY_LEVEL = { trafik: TRAFIK, halv: HALV, hel: HEL };

export const offersForLevel = (level) => BY_LEVEL[level] || [];

/** Both orders are plain numbers; neither is a verdict about which offer is better. */
export const sortOffers = (offers, sort) => {
  const key = (o) => (sort === "price" ? o.monthlySek : o.deductibleSek);
  return [...offers].sort((a, b) => {
    const av = key(a);
    const bv = key(b);
    if (av === undefined && bv === undefined) return 0;
    if (av === undefined) return 1;
    if (bv === undefined) return -1;
    return av - bv;
  });
};

/** What the signing asks for. The start day is fixed (the car is registered), so it is not asked. */
export const ACKNOWLEDGEMENTS = [
  { id: "terms-ack", label: "Jag har tagit del av förköpsinformationen och villkoren." },
  { id: "data-ack", label: "Mina uppgifter får lämnas till försäkringsbolaget för att teckna försäkringen." },
];

export const DEMO_POLICY_NUMBER = "4418-77201";

// English reading of the Swedish fixture strings above, keyed by the Swedish original.
const FIXTURE_EN = {
  "Maskinskada": "Mechanical breakdown",
  "Räddning och bärgning": "Roadside assistance and towing",
  "Rättsskydd": "Legal expenses",
  "Assistans dygnet runt": "24-hour assistance",
  "Hyrbil 75 %": "Rental car 75%",
  "Skada på andra": "Damage to others",
  "Personskada": "Personal injury",
  "Vagnskada": "Collision damage",
  "Stöld och stöldförsök": "Theft and attempted theft",
  "Brand och explosion": "Fire and explosion",
  "Glasskada på ruta": "Window glass damage",
  "Räddning och bärgning i Norden": "Roadside assistance and towing in the Nordic countries",
  "Rättsskydd vid tvist om bilen": "Legal expenses in a dispute about the car",
  "Maskinskada till 8 års ålder eller 10 000 mil": "Mechanical breakdown up to 8 years of age or 100,000 km",
  "Assistans dygnet runt i hela Norden": "24-hour assistance throughout the Nordic countries",
  "Hyrbil med 75 % av dygnskostnaden i högst 45 dagar": "Rental car at 75% of the daily cost for up to 45 days",
  "Rättsskydd upp till 250 000 kr per tvist": "Legal expenses up to SEK 250 000 per dispute",
  "Personskador på förare och passagerare": "Personal injury to the driver and passengers",
  "Skador du orsakar på andras egendom": "Damage you cause to other people's property",
  "Allt som ingår i halvförsäkringen": "Everything included in partial cover",
  "Vagnskada vid kollision, dikeskörning och skadegörelse": "Collision damage from a collision, running off the road and vandalism",
  "Hyrbil med 75 % av dygnskostnaden": "Rental car at 75% of the daily cost",
  "Vagnskada vid kollision och dikeskörning": "Collision damage from a collision and running off the road",
  "Skador på egen bil vid kollision": "Damage to your own car in a collision",
  "Hyrbil": "Rental car",
  "Skador vid uthyrning": "Damage while the car is rented out",
  "Skador vid tävling på bana": "Damage while racing on a track",
  "Alla skador på din egen bil": "All damage to your own car",
  "Stöld": "Theft",
  "Brand": "Fire",
  "Glas": "Glass",
  "Grundsjälvrisk": "Basic excess",
  "Glasreparation": "Glass repair",
  "Vid reparation i stället för byte": "For a repair instead of a replacement",
  "Sänks 500 kr efter tre skadefria år": "Reduced by SEK 500 after three claim-free years",
  "20 % av kostnaden därutöver": "20% of the cost above that",
  "Separat från övriga moment": "Separate from the other parts of the cover",
  "Kan sänkas mot högre premie": "Can be lowered for a higher premium",
  "Förköpsinformation": "Pre-purchase information",
  "Fullständiga villkor": "Full terms and conditions",
  "Jag har tagit del av förköpsinformationen och villkoren.": "I have read the pre-purchase information and the terms.",
  "Mina uppgifter får lämnas till försäkringsbolaget för att teckna försäkringen.":
    "My details may be shared with the insurer to take out the insurance.",
};

export const fixtureText = (text, language) => (language === "en" ? FIXTURE_EN[text] || text : text);

// The page's own copy, Swedish first. `{name}` marks a value filled in at render time.
const SV = {
  ack: "Ägarbytet är anmält av {seller}",
  title: "Försäkra bilen",
  trafficRule: "Om bilen är påställd ska trafikförsäkringen gälla från ägarbytesdatumet.",
  zmarta: "Försäkringsjämförelse via",
  "own.ask": "Har du redan försäkrat bilen?",
  "own.open": "Jag har redan försäkring",
  "own.prompt": "Har du redan en försäkring som gäller för {plate}?",
  "own.note": "Klargo ordnar då ingen försäkring. Är bilen påställd ska din trafikförsäkring gälla från ägarbytesdatumet.",
  "own.confirm": "Ja, jag har egen försäkring",
  back: "Tillbaka",
  "level.aria": "Omfattning",
  "level.trafik.label": "Trafik",
  "level.halv.label": "Halv",
  "level.hel.label": "Hel",
  "level.from": "från {price}",
  "level.trafik.full": "Trafikförsäkring",
  "level.halv.full": "Halvförsäkring",
  "level.hel.full": "Helförsäkring",
  "level.trafik.note": "Obligatoriskt skydd för skador du orsakar på andra. Aldrig din egen bil.",
  "level.halv.note": "Vanligtvis trafikförsäkring plus skydd för bland annat stöld, brand, glas och räddning.",
  "level.hel.note": "Vanligtvis halvförsäkring plus skydd för skador på den egna bilen.",
  "level.trafik.inSentence": "trafikförsäkring",
  "level.halv.inSentence": "halvförsäkring",
  "level.hel.inSentence": "helförsäkring",
  "offerCount.one": "1 förslag",
  "offerCount.many": "{count} förslag",
  "offers.aria": "Försäkringsförslag",
  "offers.common": "Ingår i alla förslag",
  "offer.monthly": "{price} kr/mån",
  "offer.deductible": "Självrisk {amount}",
  "terms.show": "Visa villkor i korthet",
  "terms.hide": "Dölj villkor i korthet",
  "detail.covers": "Detta ingår",
  "detail.exclusions": "Detta ingår inte",
  "detail.deductibles": "Självrisker",
  "detail.documents": "Handlingar",
  "doc.openAria": "Öppna {document} från {insurer}",
  "doc.previewMeta": "{insurer} · förmedlas via Zmarta",
  "doc.previewNote": "Exempeldokument för demonstration. Inga verkliga villkor.",
  "doc.close": "Stäng",
  "cta.continueWith": "Fortsätt med {insurer}",
  "cta.choose": "Välj ett förslag",
  "cta.nothingYet": "Inget tecknas ännu.",
  "success.kicker": "Klart",
  "success.title": "Försäkringen är tecknad",
  "success.lead": "Du har tecknat en {level} för bilen. {insurer} är försäkringsgivare.",
  "success.cta": "Fortsätt",
  "row.insurer": "Försäkringsbolag",
  "row.level": "Omfattning",
  "row.includes": "Ingår",
  "row.price": "Pris",
  "row.deductible": "Självrisk",
  "row.validFrom": "Gäller från",
  "row.regNumber": "Registreringsnummer",
  "row.policyNumber": "Försäkringsnummer",
  perYear: "{amount} per år",
  roleNote: "Zmarta jämför förslagen. Försäkringen tillhandahålls av det försäkringsbolag du väljer; Klargo är inte försäkringsgivare.",
  roleSentence: "Du tecknar försäkringen hos {insurer}. Zmarta förmedlar den och Klargo är inte försäkringsgivare.",
  "sign.title": "Teckna försäkringen",
  "start.label": "Försäkringen börjar gälla",
  "start.note": "Bilen är påställd, därför gäller försäkringen från ägarbytesdatumet.",
  "sign.terms": "Villkor och medgivanden",
  "sign.submitting": "Tecknar försäkring…",
  "sign.cta": "Teckna försäkring",
  "sign.missing": "Kvar innan du kan teckna: {items}.",
  "sign.binding": "Du binder dig först när du trycker här.",
  "sign.change": "Byt förslag",
  "missing.ack.one": "kryssa i medgivandet",
  "missing.ack.many": "kryssa i medgivandena",
  vehicle: "Personbil",
};

const EN = {
  ack: "Change of ownership reported by {seller}",
  title: "Insure the car",
  trafficRule: "If the car is licensed for use, third-party liability insurance must apply from the date of the change of ownership.",
  zmarta: "Insurance comparison via",
  "own.ask": "Have you already insured the car?",
  "own.open": "I already have insurance",
  "own.prompt": "Do you already have insurance that covers {plate}?",
  "own.note": "Klargo then arranges no insurance. If the car is licensed for use, your third-party liability insurance must apply from the date of the change of ownership.",
  "own.confirm": "Yes, I have my own insurance",
  back: "Back",
  "level.aria": "Cover",
  "level.trafik.label": "Third-party",
  "level.halv.label": "Partial",
  "level.hel.label": "Comprehensive",
  "level.from": "from {price}",
  "level.trafik.full": "Third-party liability",
  "level.halv.full": "Partial cover",
  "level.hel.full": "Comprehensive cover",
  "level.trafik.note": "Mandatory cover for damage you cause to others. Never your own car.",
  "level.halv.note": "Usually third-party liability plus cover for theft, fire, glass and roadside assistance, among other things.",
  "level.hel.note": "Usually partial cover plus cover for damage to your own car.",
  "level.trafik.inSentence": "third-party liability insurance",
  "level.halv.inSentence": "partial cover",
  "level.hel.inSentence": "comprehensive cover",
  "offerCount.one": "1 quote",
  "offerCount.many": "{count} quotes",
  "offers.aria": "Insurance quotes",
  "offers.common": "Included in all quotes",
  "offer.monthly": "SEK {price}/month",
  "offer.deductible": "Excess {amount}",
  "terms.show": "Show key terms",
  "terms.hide": "Hide key terms",
  "detail.covers": "What is covered",
  "detail.exclusions": "What is not covered",
  "detail.deductibles": "Excess",
  "detail.documents": "Documents",
  "doc.openAria": "Open {document} from {insurer}",
  "doc.previewMeta": "{insurer} · arranged through Zmarta",
  "doc.previewNote": "Sample document for demonstration. No real terms.",
  "doc.close": "Close",
  "cta.continueWith": "Continue with {insurer}",
  "cta.choose": "Choose a quote",
  "cta.nothingYet": "Nothing is taken out yet.",
  "success.kicker": "Done",
  "success.title": "The insurance has been taken out",
  "success.lead": "You have taken out {level} for the car. {insurer} is the insurer.",
  "success.cta": "Continue",
  "row.insurer": "Insurer",
  "row.level": "Cover",
  "row.includes": "Includes",
  "row.price": "Price",
  "row.deductible": "Excess",
  "row.validFrom": "Valid from",
  "row.regNumber": "Registration number",
  "row.policyNumber": "Policy number",
  perYear: "{amount} per year",
  roleNote: "Zmarta compares the quotes. The insurance is provided by the insurer you choose; Klargo is not the insurer.",
  roleSentence: "You take out the insurance with {insurer}. Zmarta arranges it and Klargo is not the insurer.",
  "sign.title": "Take out the insurance",
  "start.label": "The insurance starts",
  "start.note": "The car is licensed for use, so the insurance applies from the date of the change of ownership.",
  "sign.terms": "Terms and consents",
  "sign.submitting": "Taking out the insurance…",
  "sign.cta": "Take out insurance",
  "sign.missing": "Left before you can take out the insurance: {items}.",
  "sign.binding": "You are only bound once you press here.",
  "sign.change": "Change quote",
  "missing.ack.one": "tick the consent",
  "missing.ack.many": "tick the consents",
  vehicle: "Passenger car",
};

/** The page's copy in the buyer's language, with `{name}` values filled in. */
export const makeCopy = (language) => {
  const table = language === "en" ? EN : SV;
  return (key, values = {}) =>
    String(table[key] ?? SV[key] ?? key).replace(/\{([a-z]+)\}/g, (_, k) => (values[k] !== undefined ? values[k] : `{${k}}`));
};
